<div class="dialog-container loading-spinner">
    <mat-dialog-content>
        <div class="font-bold text-[#061F4C] text-xl text-center py-4">Loading...</div>
        <mat-spinner class="m-auto"></mat-spinner>
    </mat-dialog-content>
</div>
